(function () {
  var Discover, React, initBoomerang, legacyLightTheme, lightTheme, mountReactComponent, reloadOnWake;

  initBoomerang = require("./InitBoomerang").initBoomerang;

  reloadOnWake = require("./ReloadOnWake").reloadOnWake;

  React = require("react");

  mountReactComponent = require("MountReactComponent/MountReactComponent")["default"];

  Discover = require("Discover/Discover")["default"];

  legacyLightTheme = require("@qwilr/kaleidoscope/tokens").lightTheme;

  lightTheme = require("@qwilr/kaleidoscope/tokens").lightTheme;

  module.exports = function (
    di,
    invoke,
    $rootScope,
    $state,
    make,
    account,
    user,
    appViewState,
    scopeUi,
    loadFonts,
    styleWorker,
    notReadyForMobile,
    domFrame,
    userHistory,
    telemetry,
  ) {
    var objectFit, ref;
    window.$ = $;
    scopeUi.viewState = appViewState;
    scopeUi.domFrame = domFrame;
    scopeUi.notReadyForMobile = notReadyForMobile;
    appViewState.initialDataLoaded = true;
    scopeUi.appViewState = appViewState;
    if (scopeUi.randomTips != null) {
      scopeUi.randomTips.clearRotatingTip();
    }
    objectFit = require("object-fit/dist/polyfill.object-fit.min.js");
    objectFit.polyfill({
      selector: "video",
      fittype: "cover",
      disableCrossDomain: "true",
    });
    $rootScope.di = di;
    $rootScope.appViewState = appViewState;
    make(require("Common/Telemetry/TimeInAppTracker"), {
      trackEvent: (function (_this) {
        return function (event) {
          return telemetry.trackOnly(event);
        };
      })(this),
    });
    make(require("./Persister"));
    invoke(initBoomerang);
    invoke(require("Utils/FormFactorMonitor"));
    invoke(require("./IdentifyUser"));
    invoke(require("./UnauthorisedNotifier")["default"]);
    if (account.styleVersion !== 2) {
      if ((ref = account.renderedStyleSheet) != null ? ref.length : void 0) {
        styleWorker.addToHead(account.renderedStyleSheet, "qwilr-style-banks");
      } else {
        styleWorker.addStyles();
      }
    }
    loadFonts();
    scopeUi.discover = di.get("mountReactComponent")(React.createElement(Discover));
    invoke(require("./LogDetails"));
    invoke(require("./UserNavigation"));
    $rootScope.$on("$locationChangeSuccess", function () {
      return invoke(require("./TrialComplete"));
    });
    reloadOnWake(telemetry, account, user);
    scopeUi.bodyClassName = lightTheme + " " + legacyLightTheme;
  };
}.call(this));
